<template>
<div class="chapter">
<div class="inner_page">
<p class="default" id="d14e343"><span><br/>
<br/>
<br/></span></p>
<p class="ser"><span><img alt="2010-11-08T18-23-50-706_9781550924589_0024_001" class="imgpub" id="d14e347" src="Images/2010-11-08T18-23-50-706_9781550924589_0024_001.jpg"/></span></p>
<p class="h1c" id="d7e152924"><span>amaranth</span></p>
<p class="txca" id="d7e153424"><span><span href="#/Text/Morg_9781550924589_epub_c159_r1#d7e22331204" id="d14e351" title="Link target outside of Sample">adobo greens</span></span></p>
<p class="txca" id="d7e15023424"><span><span href="#/Text/Morg_9781550924589_epub_c161_r1#d7e22552206" id="d14e354" title="Link target outside of Sample">hortopita</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Morg_9781550924589_epub_c11_r1.vue?6b308ce2